const reviews = [
    {
      id: 1,
      name: 'veronica smigielski',
      job: 'full-stack, web developer',
      image:
        'https://media-exp1.licdn.com/dms/image/C5603AQEAuStN1IamPA/profile-displayphoto-shrink_400_400/0/1621939891181?e=1628121600&v=beta&t=BPYwf7j3jbMcpgH1U3_14tJyzkMvylHTZEH4P22eRqA',
      text:
        'Motivates and helps others',
    },
    {
      id: 2,
      name: 'anthony-tien nhat Huynh ',
      job: 'java, python developer',
      image:
        'https://media-exp1.licdn.com/dms/image/C5603AQE9UNsGQBwHpA/profile-displayphoto-shrink_400_400/0/1612337723178?e=1628121600&v=beta&t=8xzXN7u7nebzq_VSrR-RJI5RcDI_16-qNyHsQPLuzMI',
      text:
        'Motivated, team-player, awesome at development',
    },
    {
      id: 3,
      name: 'Daniel Treichel',
      job: 'java developer',
      image:
        'https://media-exp1.licdn.com/dms/image/C5603AQFNSXYDEOq7-g/profile-displayphoto-shrink_400_400/0/1598908130685?e=1628121600&v=beta&t=5rJsPCE7lv9G_lY2jXlkbF6TqwZH8encdF9jFD2_3-Y',
      text:
        'Always willing to help others',
    },
    {
      id: 4,
      name: 'Ha Nguyen',
      job: 'java developer',
      image:
        'https://media-exp1.licdn.com/dms/image/C4E03AQHmrpvckS15iw/profile-displayphoto-shrink_400_400/0/1587604769212?e=1628121600&v=beta&t=6UFsr_w3CyZ1uRUjeW9OKIJUxRwwG5UzYeuy9RE6x9s',
      text:
        'Determined, self-taught, and amazing!',
    },
  ];
  
  export default reviews;